import { useParams } from '@ksyos/router';
import { EpisodeCategory } from '@common/enums';
import { OsasOutclinicDashboard } from '@frontend/components/pages/outclinicDashboard/osas/OsasOutclinicDashboard';
import { BariatricsOutclinicDashboard } from './bariatrics/BariatricsOutclinicDashboard';

const episodeCategoryOutclinicDashboardComponents: { [key in EpisodeCategory]?: () => JSX.Element | null } = {
    [EpisodeCategory.bariatrics]: BariatricsOutclinicDashboard,
    [EpisodeCategory.somnology]: OsasOutclinicDashboard,
};

export function EpisodeCategoryOutclinicDashboard(): JSX.Element | null {
    const { episodeCategory } = useParams() as { episodeCategory: EpisodeCategory };
    const Component = episodeCategoryOutclinicDashboardComponents[episodeCategory];

    if (!Component) {
        return null;
    }

    return <Component />;
}
